import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateInstallmentPlanTemplate } from "../api/queries";
import { InstallmentPlanTemplateForm } from "../ui/InstallmentPlanTemplateForm";

export function InstallmentPlanTemplateCreatePage() {
  const nav = useNavigate({
    from: "/app/performance/installment-plan-templates/create",
  });
  const createTemplate = useCreateInstallmentPlanTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບແຜນງວດ",
              to: "/app/performance/installment-plan-templates",
            },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມແມ່ແບບແຜນງວດ</h2>
          <p className="text-muted-foreground">
            ກຳນົດ % ແລະ ຈຳນວນມື້ຫຼັງອອກໃບເກັບເງິນ
          </p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          <InstallmentPlanTemplateForm
            onSubmit={async (vals) => {
              try {
                const created = await createTemplate.mutateAsync(vals);
                nav({
                  to: "/app/performance/installment-plan-templates/$id/edit",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() =>
              nav({ to: "/app/performance/installment-plan-templates" })
            }
            submitting={createTemplate.isPending}
          />
        </div>
      </Main>
    </>
  );
}
